<template>
    <div class="mx-lg-0 mx-auto">
        <router-link v-if="homeData" to="/" class="logo-img d-inline-block">
          <img loading="lazy" :src="'https://api.telkashop.ir/storage/'+homeData.settings.site.logo" class="w-100 h-100" alt="neekshop" />
        </router-link>
      </div>
</template>
<script>
export default{
  computed:{
    homeData(){
      return this.$store.getters["front/getHomeData"]
    }
  }
}
</script>
<style>
.logo-img{
  width: 120px;
  height: 50px;
}
</style>
